import React from "react";

import Page from "../components/Page";

import ActionsList from "../components/ActionsList";

const DashboardPage = () => (
  <Page title="Dashboard">
    <ActionsList />
  </Page>
);

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.js